import React from 'react';
import clsx from 'clsx';
import { LIST_SECTION_SURFACE } from './listSectionLayout';

/**
 * THE surface a settings list's table sits on.
 *
 * Square, white and edge to edge of the reading column (feedback round 3):
 * the list pages - My activity, Recycle bin, the audit log, Users, Roles - each
 * wrapped their table in a rounded glass card, which read as a card floating
 * inside a page rather than as the page's content. A table is the content, so
 * it sits on a flat sheet with a hairline edge.
 *
 * Layout is `LIST_SECTION_SURFACE`: it takes the height the toolbar leaves and
 * clips, so the Table's own container stays the single scroller. Pair it with
 * `<Table min="min-h-0" max="max-h-full">` as before.
 */
const ListSurface: React.FC<{ className?: string; children: React.ReactNode }> = ({
  className,
  children,
}) => (
  <div
    data-testid="list-surface"
    className={clsx(LIST_SECTION_SURFACE, 'border border-hairline bg-surface', className)}
  >
    {children}
  </div>
);

export default ListSurface;
